import { useState } from 'react';
import styled from 'styled-components';
import Icon from './icon';
// import IconStar from 'star.svg'; // Findes ikke endnu

export type RatingsProps = {
  value?: number;
  max?: number;
  className?: string;
  onChange?: (value: number) => void;
};

// Bruges ikke endnu.

export const Ratings: React.FC<RatingsProps> = ({ value = 0, max = 5, className = '', onChange }) => {
  const [rating, setRating] = useState(value);

  const isChangeable = !!onChange;

  return (
    <StyledRatings
      className={className}
      onMouseOut={() => {
        if (isChangeable) {
          setRating(value);
        }
      }}
    >
      {Array.from(Array(max).keys()).map((_, i) => {
        if (isChangeable) {
          return (
            <button
              onClick={() => {
                setRating(i + 1);
                onChange(i + 1);
              }}
              key={i}
              onMouseEnter={() => {
                setRating(i + 1);
              }}
            >
              <Icon name={rating > i ? 'star' : 'star-outline'} className="star" />
            </button>
          );
        }

        return <Icon name="star" key={i} className="star" />;
      })}
    </StyledRatings>
  );
};

export const StyledRatings = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  margin: 1rem 0;

  button {
    border: none;
    color: var(--primary-base);
    padding: 0.4rem 0.5rem 0.4rem 0;
    height: auto;
  }

  .star {
    /* width: ; */
    display: flex;
    line-height: 24px;
    font-size: 24px;
    color: var(--primary-base);
    pointer-events: none;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export default Ratings;
